'use strict';

var $ = window.jQuery;

function init() {

	var googleCallTrackingCallback = function( formatted_number, unformatted_number ) {
		$(".trackTel").each(function() {
			var $this = $(this),
				$display = $('.trackTel__numberDisplay', $this);
			$this.attr( "href", "tel:" + unformatted_number);
			if ($display.length !== 0) {
				$display.text( formatted_number );
			} else  {
				$this.text( formatted_number );
			}
		});
	};

	if ( typeof(_googWcmGet) != "undefined" && _googWcmGet != null ) {
		_googWcmGet(googleCallTrackingCallback, '612-424-2205');
	}
	
	window.TestCallTracking = googleCallTrackingCallback; // This is for testing. In console simply run something like: TestCallTracking('555','666');
}

var CallTracking = {
	init: init
};

module.exports = CallTracking;